export default __webpack_public_path__ + "static/media/firebase.e6583a29.svg";